import TextInput from '../shared/TextInput';
import SelectBox from '../shared/select/SelectBox';
import DeleteIcon from '../../assets/icons/DeleteIcon';

const LeadProcedureItem = (props) => {
  const {
    procedures = [],
    procedureId,
    quantity,
    onProcedureChange,
    onQuantityChange,
    onDelete
  } = props;

  return (
    <div className='lead-modal__procedure-item'>
      <SelectBox
        value={procedureId}
        onChange={onProcedureChange}
        options={procedures.map((p) => ({ label: p.name, value: p.id }))}
      />
      <TextInput value={quantity} onChange={(e) => onQuantityChange(e.target.value)} type='number' placeholder='QTY' />
      <DeleteIcon color="#F53434" onClick={onDelete} />
    </div>
  );
};

export default LeadProcedureItem;
